import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Figure,
  Form,
  Row,
} from "react-bootstrap";
import { sponsors } from "../../../components/shared/constraints";
import { BiPlusCircle } from "react-icons/bi";
import AddEdit from "../SuvicharManager/AddEdit";
import {
  deleteSuvicharApi,
  getSuvicharApi,
} from "../../../hooks/ApisContainer/User";
import useToastContext from "../../../hooks/useToastContext";
import AuthContext from "../../../hooks/context/AuthContext";
import moment from "moment";
import { Link } from "react-router-dom";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { removeMultiSpace } from "../../../helper/helper";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import NoDataFound from "../../../components/shared/Loader/NoDataAnimation";
import Swal from "sweetalert2";
import OPagination from "../../../components/shared/pagination/OPagination";
const MemberSuvichar = () => {
  const notification = useToastContext();
  const { user } = useContext(AuthContext);

  // ALL STATE
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [userList, setUserList] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [modalType, setModalType] = useState("");
  const [currentActiveData, setCurrentActiveData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleShowModal = (type, data) => {
    setShow(!show);
    setModalType(type);
    if (type == "edit") {
      setCurrentActiveData(data);
    }
  };

  useEffect(() => {
    fetchedGetUsers();
  }, []);

  const fetchedGetUsers = (data = {}) => {
    const requestPayload = {
      ...data,
      page: currentPage,
      pageSize: rowsPerPage,
    };
    getSuvicharApi(requestPayload, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setUserList(response?.docs);
        setTotalPages(response?.totalDocs);
      }
    });
  };

  function formatTimestampWithMoment(timestamp) {
    return moment(timestamp).format("DD-MM-YYYY hh:mm A");
  }

  const handleResetFilter = () => {
    setFilterData({});
    fetchedGetUsers();
  };

  const handleApplyFilter = () => {
    const trimmedFilterData = {
      ...filterData,
      keyword: filterData.keyword ? filterData.keyword.trim() : "",
    };
    fetchedGetUsers(trimmedFilterData);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handelDelete = async (id) => {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Delete",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { id };
          deleteSuvicharApi(requestPayload, notification, (loading, error) => {
            setLoader(loading);
            if (!error) {
              fetchedGetUsers();
            }
          });
        } catch (error) {
          console.error("error:", error);
          setLoader(false);
        }
      }
    });
  };

  const handlePageChange = async (event) => {
    setCurrentPage(event?.selected + 1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchedGetUsers();
  }, [currentPage]);

  return (
    <div className="right-panel p-3">
      <div class="common-heading text-start mb-3">
        <h4 className="mb-3 fw-bold fs-5 ">Suvichar Post</h4>
      </div>

      <div className="bg-white border text-start p-3 mb-4">
        <Row className="gx-2">
          <Col lg={3} md={4}>
            <Form.Control
              type="text"
              placeholder="Search..."
              name="keyword"
              value={filterData.keyword || ""}
              onChange={handleFilterChange}
              onInput={removeMultiSpace}
            />
          </Col>

          <Col lg={3} md={4} className="mt-lg-0 mt-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <Button
                  type="button"
                  className="bg-orange border-0 me-2 normal-size"
                  onClick={handleApplyFilter}
                >
                  Filter
                </Button>
                <Button
                  type="button"
                  className="bg-orange border-0 normal-size me-2"
                  onClick={handleResetFilter}
                >
                  Reset
                </Button>
              </div>
              <Button
                type="button"
                onClick={() => handleShowModal("add")}
                className="bg-black btn text-white border-0 normal-size"
              >
                Add <BiPlusCircle />
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      <section className="sponser-sec  pt-0 our-team-member pb-0 ">
        <div className="achiever-box gx-2 d-flex flex-wrap">
          {loader ? (
            <Row className="w-100">
              <Col lg={12} md={12} xs={12} className="mb-3 box-member">
                <Card className="sponser-cards speaker-box-layout2 position-relative">
                  <Card.Body className="text-start">
                    <span>
                      <LottiLoader height={120} width={120} loader={true} />
                    </span>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : (
            <>
              {userList &&
                userList?.length > 0 &&
                userList.map((item, index) => {
                  return (
                    <Col
                      lg={12}
                      md={12}
                      xs={12}
                      className="mb-3 box-member"
                      key={item?._id}
                    >
                      <Card className="sponser-cards speaker-box-layout2 position-relative">
                        <Card.Body className="text-start">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <Card.Title style={{ fontWeight: "bold" }}>
                                {item?.userData?.firstName}&nbsp;
                                {item?.userData?.lastName}
                              </Card.Title>
                              <Card.Text
                                style={{
                                  color: "#ff6004",
                                  fontSize: "14px",
                                  fontWeight: "bold",
                                }}
                                className="mb-2"
                              >
                                {item?.createdAt &&
                                  formatTimestampWithMoment(item?.createdAt)}
                              </Card.Text>
                            </div>
                            {user?._id == item?.userId && (
                              <div>
                                <Button
                                  variant="outline-primary"
                                  onClick={() => handleShowModal("edit", item)}
                                  className="me-2"
                                >
                                  <MdEdit />
                                </Button>
                                <Button
                                  variant="outline-danger"
                                  onClick={() => handelDelete(item?._id)}
                                >
                                  <MdDeleteForever />
                                </Button>
                              </div>
                            )}
                          </div>
                          {item?.suvichar && (
                            <Card.Text
                              className="fw-bold mb-1"
                              style={{ textAlign: "justify" }}
                            >
                              {item?.suvichar}
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}
            </>
          )}

          {!loader && userList?.length == 0 && (
            <Row className="w-100">
              <Col lg={12} md={12} xs={12} className="mb-3 box-member">
                <Card className="sponser-cards speaker-box-layout2 position-relative">
                  <Card.Body className="text-start">
                    <NoDataFound
                      height={200}
                      width={200}
                      firstMessage="No Suvichar found."
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </div>

        {!loader && userList && userList.length > 0 && (
          <Row className="w-100">
            <Col lg={12} md={12} xs={12} className="mb-3 box-member">
              <Card className="sponser-cards speaker-box-layout2 position-relative">
                <Card.Body className="text-start">
                  <OPagination
                    pageCount={Math.ceil(totalPages / 10)}
                    handlePageClick={(e) => handlePageChange(e)}
                    page={currentPage}
                  />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        {show && (
          <AddEdit
            show={show}
            onHide={handleShowModal}
            modalType={modalType}
            currentActiveData={currentActiveData}
            fetchedGetUsers={fetchedGetUsers}
            setCurrentActiveData={setCurrentActiveData}
          />
        )}
      </section>
    </div>
  );
};

export default MemberSuvichar;

// No of Members,no of volumnteers,no of Active user
